export enum HTTP_CODE {
    ECONNABORTED = 'ECONNABORTED'
}
